<template>
    <div class="modal fade" id="setNewPasswordModal" tabindex="-1" role="dialog" data-backdrop="static"
         aria-labelledby="setNewPasswordModalLabel">
        <div class="modal-dialog modal-lg"  role="document">
            <div class="modal-content" v-if="!isLoading">
                <div class="modal-header">
                    <div class="min-title" v-if="stage===1">
                        <h3>Reset Password</h3>
                    </div>
                    <div class="min-title" v-if="stage===2">
                        <h3>Enter Your Authentication Code</h3>
                    </div>
                    <div class="big-title" v-if="stage===3">
                        <img src="../../assets/information-green.png" alt="info">
                        <p>Why didn't the mobile confirmation code come</p>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="modal-body-content" @keyup.enter="passwordEntered" v-if="stage===1">
                        <label for="password">New Password</label>
                        <input type="password" name="password" id="password" v-model="password">
                        <label for="re-password">Confirm New Password</label>
                        <input type="password" name="re-password" id="re-password" v-model="confirmed_password">
                        <p class="error-label">{{errorText}}</p>
                        <button class="next-button" @click="passwordEntered">
                            <span class="next-button-text">NEXT</span>
                        </button>
                    </div>
                    <div class="modal-body-content" v-if="stage===2">
                        <label for="auth-code"></label>
                        <input type="text" name="auth-code" id="auth-code" v-model="authCode" @keyup="authCodeKeyUp">
                        <div class="progress-bar-container">
                            <p>{{countDown.minutes}}:{{countDown.seconds}}</p>
                            <div class="progress-bar" id="progress-bar">

                            </div>
                        </div>
                        <button class="next-button" :disabled="isResetDisabled" @click="authCodeEntered">
                            <span class="next-button-text">RESET PASSWORD</span>
                        </button>
                        <p id="info-text" @click="helpClicked">Didn't you get your code?</p>
                    </div>
                    <div class="modal-body-content" v-if="stage===3">
                        <p class="help-content">Your mobile phone number may not be updated/registered</p>
                        <p class="help-content">You can update/register your phone number from the profile tab on
                            settings</p>
                        <p class="help-content">Please contact support if you can't reset your password vtisupport@comodo.com</p>
                        <button class="next-button" @click="backClicked">
                            <span class="next-button-text">BACK</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="sk-cube-grid" v-if="isLoading">
                <div class="sk-cube sk-cube1" :class="green"></div>
                <div class="sk-cube sk-cube2" :class="green"></div>
                <div class="sk-cube sk-cube3" :class="green"></div>
                <div class="sk-cube sk-cube4" :class="green"></div>
                <div class="sk-cube sk-cube5" :class="green"></div>
                <div class="sk-cube sk-cube6" :class="green"></div>
                <div class="sk-cube sk-cube7" :class="green"></div>
                <div class="sk-cube sk-cube8" :class="green"></div>
                <div class="sk-cube sk-cube9" :class="green"></div>
            </div>
        </div>

    </div>
</template>

<script>
    import Constants from '@/utils/constants'
    import LoadingModal from '@/components/modals/LoadingModal.vue'
    import Common from '@/utils/Common.vue'
    const MIN_PASSWORD_LENGTH = 8;

    export default {
        name: "setNewPassword",
        components: {
            LoadingModal: LoadingModal
        },
        props: {
            forgotPasswordHash: {
                type: String,
                required: false
            }
        },
        mixins: [Common],
        data() {
            return {
                stage: 1,
                sid: null,
                phone: null,
                password: null,
                confirmed_password: null,
                email: null,
                countdownSecondDuration: 120,
                countDown: {
                    minutes: null,
                    seconds: null,
                    leftSeconds: 120
                },
                isLoading: false,
                isResetDisabled: true,
                authCode: null,
                errorText: null
            }
        },
        methods: {
            authCodeKeyUp() {
                if (this.authCode.length === 6){
                    this.isResetDisabled = false;
                }
            },
            helpClicked() {
                this.stage++;
            },
            backClicked() {
                this.stage--;
            },
            authCodeEntered() {
                this.isLoading = true;
                this.isResetDisabled = true;
                let body = {
                    sid: this.sid,
                    phone: this.phone,
                    auth_code: this.authCode,
                    password: this.password,
                    confirmed_password: this.confirmed_password,
                    email: this.email
                };
                this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/updatePasswordNotPrimaryUser', body)
                    .then(response => { // Success
                        if (response.body.return_code === Constants.ReturnCodes.Success) {
                            this.hideModal();
                            this.isLoading = false;
                            this.showSuccessMessage("Password has updated successfully.");
                        }   else if (response.body.return_code === Constants.ReturnCodes.ArgumentError) {
                            this.isLoading = false;
                            this.showErrorMessage("Authentication code is wrong.")
                        }
                    }, response => {
                        this.hideModal();
                        this.isLoading = false;
                        this.showErrorMessage("Couldn't update password.")
                    });
            },
            startTimer() {
                let component = this;
                let timer = setInterval(function () {
                    component.countDown.leftSeconds--;
                    let minutes = Math.floor(component.countDown.leftSeconds / 60);
                    let seconds = component.countDown.leftSeconds - minutes * 60;
                    component.countDown.minutes = "0" + minutes;
                    if (seconds < 10) {
                        component.countDown.seconds = "0" + seconds;
                    } else {
                        component.countDown.seconds = seconds;
                    }
                    let percent = ((component.countdownSecondDuration - component.countDown.leftSeconds) / component.countdownSecondDuration) * 100;
                    $("#progress-bar").width(percent + "%");
                    if (seconds === 0 && minutes === 0) {
                        component.isResetDisabled = true;
                        clearInterval(timer);
                    }
                }, 1000)
            },
            passwordEntered() {
                if (this.password != null && this.confirmed_password != null
                    && this.password.length !== 0 || this.password.length !== 0) {
                    if (this.password.length >= MIN_PASSWORD_LENGTH ) {
                        if (this.password === this.confirmed_password){
                            this.isLoading = true;
                            let body = {
                                forgotPasswordHash: this.forgotPasswordHash
                            };

                            this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/sendForgotPasswordSms', body)
                                .then(response => { // Success
                                    this.sid = response.body.data.sid;
                                    this.phone = response.body.data.phone;
                                    this.email = response.body.data.email;
                                    this.stage = this.stage + 1;
                                    this.startTimer();
                                    this.isLoading = false;
                                }, response => {
                                    this.stage = this.stage + 1;
                                    this.startTimer();
                                    this.isLoading = false;
                                });
                        }   else{
                            this.errorText = "Passwords are not the same."
                        }
                    }   else{
                        this.errorText = "Password must be at least 8 character."
                    }
                }

            },
            showModal() {
                $('#setNewPasswordModal').modal('show');
            },
            hideModal() {
                $('#setNewPasswordModal').modal('hide');
            }
        },
        mounted() {
            $('#setNewPasswordModal').modal({show: false});
            // this.startTimer();
        }
    }
</script>

<style scoped>

    .modal-body-content {
        display: flex;
        flex-direction: column;
    }

    .modal-dialog {
        height: 300px !important;
        width: 400px !important;
    }

    .min-title {
        height: 30px !important;
        color: white;
        padding: 0 0 0 16px !important;
        display: flex;
        align-items: center;
    }

    .big-title {
        height: 50px !important;
        color: white;
        padding: 0 0 0 16px !important;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .big-title img {
        margin-bottom: 8px;
    }

    .big-title p {
        color: #00fea9;
    }

    .min-title h3 {
        margin: 0 !important;
    }

    .modal-body {
        background: #0A4C51;
        display: flex;
        flex-direction: column;
    }

    label {
        color: white;
    }

    input {
        width: 100%;
        margin-bottom: 16px;
    }

    .next-button {
        border: 0;
        border-radius: 10px;
        padding: 0 !important;
        margin: 0 !important;
        color: white;
        background: #00929B;
        align-self: flex-end;
        height: 24px;
    }

    .next-button-text {
        padding: 0 32px 0 32px;
    }

    .progress-bar-container {
        background: white;
        height: 26px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-bottom: 16px;
    }

    .progress-bar-container p {
        position: fixed;
        align-self: flex-end;
        margin: 0;
        padding-right: 4px;
    }

    .progress-bar {
        height: 26px;
        background: #00FFAB;
    }

    #info-text {
        cursor: pointer;
        align-self: flex-end;
        color: white;
        margin-top: 8px;
        font-size: 12px;
    }

    .help-content {
        color: white;
    }

    .sk-cube{
        background-color: rgba(0, 255, 169, 1) !important;
    }

    .sk-cube-grid {
        width: 100px;
        height: 100px;
        margin: auto;
        position: absolute;
        top:0;
        bottom: 0;
        left: 0;
        right: 0;
    }

    .sk-cube-grid .sk-cube {
        width: 33%;
        height: 33%;
        background-color: #333;
        float: left;
        -webkit-animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
        animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
    }
    .sk-cube-grid .sk-cube1 {
        background-color: rgba(0, 255, 169, 1) !important;
        -webkit-animation-delay: 0.2s;
        animation-delay: 0.2s; }
    .sk-cube-grid .sk-cube2 {
        background-color: rgba(0, 255, 169, 1) !important;
        -webkit-animation-delay: 0.3s;
        animation-delay: 0.3s; }
    .sk-cube-grid .sk-cube3 {
        background-color: rgba(0, 255, 169, 1) !important;
        -webkit-animation-delay: 0.4s;
        animation-delay: 0.4s; }
    .sk-cube-grid .sk-cube4 {
        background-color: rgba(0, 255, 169, 1) !important;
        -webkit-animation-delay: 0.1s;
        animation-delay: 0.1s; }
    .sk-cube-grid .sk-cube5 {
        background-color: rgba(0, 255, 169, 1) !important;
        -webkit-animation-delay: 0.2s;
        animation-delay: 0.2s; }
    .sk-cube-grid .sk-cube6 {
        background-color: rgba(0, 255, 169, 1) !important;
        -webkit-animation-delay: 0.3s;
        animation-delay: 0.3s; }
    .sk-cube-grid .sk-cube7 {
        background-color: rgba(0, 255, 169, 1) !important;
        -webkit-animation-delay: 0s;
        animation-delay: 0s; }
    .sk-cube-grid .sk-cube8 {
        background-color: rgba(0, 255, 169, 1) !important;
        -webkit-animation-delay: 0.1s;
        animation-delay: 0.1s; }
    .sk-cube-grid .sk-cube9 {
        background-color: rgba(0, 255, 169, 1) !important;
        -webkit-animation-delay: 0.2s;
        animation-delay: 0.2s; }

    @-webkit-keyframes sk-cubeGridScaleDelay {
        0%, 70%, 100% {
            -webkit-transform: scale3D(1, 1, 1);
            transform: scale3D(1, 1, 1);
        } 35% {
              -webkit-transform: scale3D(0, 0, 1);
              transform: scale3D(0, 0, 1);
          }
    }

    @keyframes sk-cubeGridScaleDelay {
        0%, 70%, 100% {
            -webkit-transform: scale3D(1, 1, 1);
            transform: scale3D(1, 1, 1);
        } 35% {
              -webkit-transform: scale3D(0, 0, 1);
              transform: scale3D(0, 0, 1);
          }
    }

    .error-label{
        color: red;
    }
</style>



// WEBPACK FOOTER //
// src/components/modals/SetNewPasswordModal.vue